import { en } from 'app/i18/translations.js';

export class errorText {
  constructor() {}

  static errorMessage(code) {
    return en[code] ? en[code] : 'Something went wrong. Please try again later';
  }
}
